// extracted by mini-css-extract-plugin
export default {"card":"card_card__w+SrK","card__title":"card_card__title__d4zfn","card__body":"card_card__body__wPpgF"};